import { env } from '../../utils/env';
import { beginSocialRedirect, shouldUseSocialRedirect } from './socialRedirect.web';

declare global {
	interface Window {
		FB?: any;
		fbAsyncInit?: () => void;
	}
}

const APP_ID = env('FACEBOOK_APP_ID');
console.log('APP_ID test', APP_ID);

function loadFacebookSDK(): Promise<void> {
	if (typeof window === 'undefined') return Promise.resolve();
	if (window.FB) return Promise.resolve();

	return new Promise((resolve, reject) => {
		if (!APP_ID) {
			reject(new Error('Missing Facebook App ID'));
			return;
		}

		window.fbAsyncInit = function () {
			window.FB.init({
				appId: APP_ID,
				cookie: true,
				xfbml: false,
				version: 'v19.0',
			});
			resolve();
		};

		const script = document.createElement('script');
		script.async = true;
		script.defer = true;
		script.src = 'https://connect.facebook.net/en_US/sdk.js';
		script.onerror = () => reject(new Error('Failed to load Facebook SDK'));
		document.body.appendChild(script);
	});
}

export async function facebookSignIn(): Promise<string> {
	console.log('[FacebookSignIn][web] start');

	// The installed app cannot get the popup's answer back; the page goes to Facebook
	// instead and the login resumes from the return URL on the next boot.
	if (shouldUseSocialRedirect()) {
		return beginSocialRedirect('facebook');
	}

	await loadFacebookSDK();

	return new Promise((resolve, reject) => {
		window.FB.login(
			(res: any) => {
				const token = res?.authResponse?.accessToken;
				if (token) resolve(token);
				else reject(new Error('Facebook login failed'));
			},
			{ scope: 'public_profile,email,user_birthday,user_gender,user_location' },
		);
	});
}
